import { render, staticRenderFns } from "./process-loader.vue?vue&type=template&id=581157e9&scoped=true"
import script from "./process-loader.vue?vue&type=script&lang=js"
export * from "./process-loader.vue?vue&type=script&lang=js"
import style0 from "./process-loader.vue?vue&type=style&index=0&id=581157e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581157e9",
  null
  
)

export default component.exports